export default __webpack_public_path__ + "icon_email.d74309c00341040bc80e42fa2fe74e75.svg";